<ng-container *ngIf="valueFormGroup && valueFormControl">
  <form [formGroup]="valueFormGroup">
    <ng-container [ngTemplateOutlet]="!useLabel ? matSelectTpl : defaultTpl"></ng-container>

    <ng-template #defaultTpl>
      <div class="d-flex flex-wrap align-items-start mb-6">
        <label
          *ngIf="label"
          for="{{ controlName }}"
          class="col-12 col-lg-4 col-form-label {{ required ? 'required' : '' }}"
          >{{ label }}</label
        >
        <div class="col-12 col-lg-8 {{ class }}">
          <ng-container *ngIf="useFilterList; else noFilterTpl">
            <div class="position-relative">
              <input
                placeholder="{{ placeholder }}"
                [readonly]="readOnly"
                class="form-control form-control-solid"
                type="text"
                matInput
                (focus)="onFocus()"
                [formControl]="myControl"
                [matAutocomplete]="auto"
                [class.border-danger]="myControl.dirty && isInvalid"
                #trigger="matAutocompleteTrigger"
              />

              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                (optionSelected)="handleChangeValue($event)"
              >
                <mat-option *ngFor="let option of optionsSelected | async" [value]="option">
                  <ng-container
                    *ngTemplateOutlet="optionPropertyTpl; context: { option }"
                  ></ng-container>
                </mat-option>
              </mat-autocomplete>

              <span
                *ngIf="!readOnly; else noTriggerIcon"
                class="svg-icon svg-icon-1 cursor-pointer"
                [inlineSVG]="ICONS.IC_ARROW_MINI_DOWN"
                (click)="trigger.openPanel(); $event.stopPropagation()"
              ></span>

              <ng-template #noTriggerIcon>
                <span
                  class="svg-icon svg-icon-1 cursor-pointer"
                  [inlineSVG]="ICONS.IC_ARROW_MINI_DOWN"
                ></span>
              </ng-template>
            </div>
          </ng-container>

          <ng-template #noFilterTpl>
            <ng-container [ngTemplateOutlet]="matSelectTpl"></ng-container>
          </ng-template>

          <mat-error *ngIf="isNotValidAndDirty && hasErrors">
            <div class="px-2 mt-2">
              {{ displayErrorMessage(controlName) }}
            </div>
          </mat-error>
        </div>
      </div>
    </ng-template>

    <ng-template #matSelectTpl>
      <mat-select
        [formControlName]="controlName"
        [placeholder]="placeholder"
        (selectionChange)="handleChangeSelect($event)"
      >
        <mat-select-trigger *ngIf="valueFormControl.value">{{
          valueFormControl.value.label
        }}</mat-select-trigger>
        <mat-option
          *ngFor="let option of optionsData | async"
          [value]="option"
          [disabled]="option?.disabled"
        >
          <ng-container *ngTemplateOutlet="optionPropertyTpl; context: { option }"></ng-container>
        </mat-option>
      </mat-select>
    </ng-template>

    <ng-template #optionPropertyTpl let-option="option">
      <div class="py-2">
        <span>{{ displayFn(option) }}</span>
        <div class="fs-12 mt-1">
          <span *ngIf="option.labelExtra" [innerHTML]="option.labelExtra"></span>
          <span *ngIf="option.description" class="text-gray-700">{{ option.description }}</span>
        </div>
      </div>
    </ng-template>
  </form>
</ng-container>
